import { type Position } from '../types'

type PositionResult = {
  x: number
  y: number
}

export type ScreenMatrix = {
  a: number
  b: number
  c: number
  d: number
  e: number
  f: number
}

export type ElementBounds = {
  left: number
  right: number
  top: number
  bottom: number
  width: number
  height: number
}

type ElementPlacement = {
  elementRect: ElementBounds
  screenMatrix: ScreenMatrix
}

export const calculatePosition = (placement: ElementPlacement, position: Position): PositionResult =>
  toUserSpace(clientAnchor(placement.elementRect, position), placement.screenMatrix)

const clientAnchor = (rect: ElementBounds, position: Position): PositionResult => {
  switch (position) {
    case 'left':
      return { x: rect.left, y: centerY(rect) }
    case 'right':
      return { x: rect.right, y: centerY(rect) }
    case 'top':
      return { x: centerX(rect), y: rect.top }
    case 'bottom':
      return { x: centerX(rect), y: rect.bottom }
  }
}

const centerX = (rect: ElementBounds): number => rect.left + rect.width / 2

const centerY = (rect: ElementBounds): number => rect.top + rect.height / 2

export const toUserSpace = (point: PositionResult, matrix: ScreenMatrix): PositionResult => {
  const { a, b, c, d, e, f } = matrix
  const determinant = a * d - b * c
  if (determinant === 0) return { x: 0, y: 0 }

  return {
    x: (d * point.x - c * point.y + c * f - d * e) / determinant,
    y: (a * point.y - b * point.x + b * e - a * f) / determinant,
  }
}
